"use strict";
import { actionsMenu } from "../shared/styleClasses";
export const styles = {
  templatesPageContainer: {
    padding: "40px",
    rowGap: 4
  },
  templatesPageHeader: {
    fontWeight: "bold",
    fontSize: "38px",
    color: "#666666"
  },
  actionsMenu,
  modalStyleOverrides: {
    height: "auto",
    maxHeight: "84vh",
    width: "900px",
    padding: "40px"
  },
  modalContainer: {
    width: "100%",
    height: "100%",
    rowGap: 3,
    overflow: "auto"
  },
  modalTitle: {
    fontWeight: "bold",
    color: "#084D6D",
    fontSize: "25px"
  }
};
